import { render, staticRenderFns } from "./albumList.vue?vue&type=template&id=0700f4c9&scoped=true"
import script from "./albumList.vue?vue&type=script&lang=js"
export * from "./albumList.vue?vue&type=script&lang=js"
import style0 from "./albumList.vue?vue&type=style&index=0&id=0700f4c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0700f4c9",
  null
  
)

export default component.exports